import { ExternalLinkProps } from "@/components/examinee/ExternalLink";
import { Footer } from "@/components/examinee/Footer";
import { SxProps, Theme } from "@mui/material";

type ExamineeFooterProps = {
  showHowToReadReport?: boolean;
  sx?: SxProps<Theme>;
};
export function ExamineeFooter({
  showHowToReadReport = false,
  sx,
}: ExamineeFooterProps) {
  const FOOTER_LINKS: ExternalLinkProps[] = [];

  FOOTER_LINKS.push(
    {
      children: "利用規約",
      href: "/examinee/terms_of_service",
      target: "_blank",
    },
    {
      children: "サービスの位置付け",
      href: "/examinee/service_positioning",
      target: "_blank",
    }
  );

  if (showHowToReadReport) {
    FOOTER_LINKS.push({
      children: "レポートの読み方",
      href: "/doc/how-to-read-the-report.pdf",
      target: "_blank",
    });
  }

  FOOTER_LINKS.push(
    {
      children: "よくある質問",
      href: "https://accelstars.notion.site/SLEEP-COMPASS-1965f666810580998eb3dc2d30c3ed79",
      target: "_blank",
    },
    {
      children: "チャットでお問合せ",
      href: "/help/bot.html",
      target: "_blank",
    },
    {
      children: "フォームでお問合せ",
      href: "https://docs.google.com/forms/d/e/1FAIpQLSfFP5qmDil0qpYu7Fjsy7Iw9-GrH7e-2vOLykBw5tRhzcGSnQ/viewform",
      target: "_blank",
    }
  );

  return <Footer sx={sx} links={FOOTER_LINKS} />;
}
